import React from "react";
const Discordbot = () => {
  return (
    <>
      <>
  <div id="main-area">
  <div id="article">
  <h1 id="about">
    {" "}
    <a href="/about" aria-labelledby="about" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    EMI Discord BOT Description
  </h1>
  <p>
    For an overview of EnbyBase, please visit our{" "}
    <strong>
      <a href="/">Home</a>
    </strong>{" "}
    page.<br />
    For detailed descriptions of EnbyBase, please visit our{" "}
    <strong>
      <a href="/about">About</a>
    </strong>{" "}
    page.<br />
    <strong>
      <a href="/miles">EMI</a>
    </strong>, EnbyBase Miles Interface 
  </p>
  <h2 id="Developer">
    {" "}
    <a href="https://discordapp.com/users/1165970007264612372" aria-labelledby="Developer" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Developer
  </h2>
  <p>
  Developer of EnbyBase BOT is <a href="https://discordapp.com/users/1165970007264612372">New_PrestigeFlight</a>.
  </p>
  <h2 id="Sourcecode">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Sourcecode" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Source Code
  </h2>
  <p>
  This BOT is built using <a href="https://discord.js.org">Discord.js</a>.
  <br />Source code will be published on <a href="https://github.com/prestigeflight/EnbyBase-BOT">Github PrestigeFlight's Repository</a>.
  </p>
  <h2 id="Disclaimer">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Disclaimer" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Disclaimer
  </h2>
  <p>
  This BOT is currently available in Discord servers of EnbyBase Alliance. Please follow EMI Terms of Service.
  </p>
</div>
</div>
</>

    </>
  );
}

export default Discordbot;